import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import { createStore } from 'vuex-extensions'

import store from './modules/store'
import selfbook from './modules/selfbook'
import faqs from './modules/faqs'
import ui from './modules/ui'
import bookshelf from './modules/bookshelf'
import bookList from './modules/bookList'
import auth from './modules/auth'
import cart from './modules/cart'
import account from './modules/account'
import event from './modules/event'
import search from './modules/search'
import newsletter from './modules/newsletter'
import coupon from './modules/coupon'
import register from './modules/register'
import payment from './modules/payment'
import supplement from './modules/supplement'

Vue.use(Vuex, axios)

const initToken = localStorage.getItem('token') || ''

if (initToken) {
  axios.defaults.headers.common['Authorization'] = `Bearer ${initToken}`
}

export default createStore(Vuex.Store, {
  modules: {
    account,
    auth,
    bookshelf,
    bookList,
    cart,
    coupon,
    event,
    faqs,
    newsletter,
    payment,
    register,
    search,
    selfbook,
    store,
    supplement,
    ui
  }
})
